import { toLower } from 'lodash';
import { isBooleanTrue, isObjectNotEmpty, isStringNotEmpty } from '../utils/objectUtils';

class Insurance {
	id = null;
	userId = null;
	subscriberId = null;

	rank = 'OTHER';
	hierarchy = 'UNKNOWN';
	status = 'UNKNOWN';
	isMedicare = false;
	isMedicaid = false;

	firstName = null;
	firstNameLower = null;
	middleName = null;
	lastName = null;
	lastNameLower = null;
	suffix = null;

	gender = null;
	dateOfBirth = null;

	socialSecurityNumber = null;
	socialSecurityNumberLastFour = null;

	patientPhone = null;
	patientAddress = null;
	relationshipToSubscriber = 'MEMBER';

	insurancePhone = null;
	insuranceAddress = null;

	subscriberFirstName = null;
	subscriberLastName = null;
	subscriberPhone = null;
	subscriberAddress = null;

	payerName = null;
	payerCode = null;
	planName = null;
	planNumber = null;
	groupName = null;
	groupNumber = null;
	planType = null;
	policyType = null;

	rxBin = null;
	rxPcn = null;
	rxGroup = null;

	effectiveFromDate = null;
	effectiveToDate = null;

	frontPhotoRefId = null;
	backPhotoRefId = null;

	constructor(userInsurance) {
		if (isObjectNotEmpty(userInsurance)) {
			if (isStringNotEmpty(userInsurance.id)) { this.id = userInsurance.id; }
			if (isStringNotEmpty(userInsurance.userId)) { this.userId = userInsurance.userId; }
			if (isStringNotEmpty(userInsurance.subscriberId)) { this.subscriberId = userInsurance.subscriberId; }

			if (isStringNotEmpty(userInsurance.rank)) { this.rank = userInsurance.rank; }
			if (isStringNotEmpty(userInsurance.hierarchy)) { this.hierarchy = userInsurance.hierarchy; }
			if (isStringNotEmpty(userInsurance.status)) { this.status = userInsurance.status; }
			if (isBooleanTrue(userInsurance.isMedicare)) { this.isMedicare = true; }
			if (isBooleanTrue(userInsurance.isMedicaid)) { this.isMedicaid = true; }

			if (isStringNotEmpty(userInsurance.firstName)) {
				this.firstName = userInsurance.firstName;
				this.firstNameLower = toLower(userInsurance.firstName);
			}
			if (isStringNotEmpty(userInsurance.lastName)) {
				this.lastName = userInsurance.lastName;
				this.lastNameLower = toLower(userInsurance.lastName);
			}
			if (isStringNotEmpty(userInsurance.middleName)) { this.middleName = userInsurance.middleName; }
			if (isStringNotEmpty(userInsurance.suffix)) { this.suffix = userInsurance.suffix; }

			if (isStringNotEmpty(userInsurance.gender)) { this.gender = userInsurance.gender; }
			if (isStringNotEmpty(userInsurance.dateOfBirth)) { this.dateOfBirth = userInsurance.dateOfBirth; }

			if (isStringNotEmpty(userInsurance.socialSecurityNumber)) { this.socialSecurityNumber = userInsurance.socialSecurityNumber; }
			if (isStringNotEmpty(userInsurance.socialSecurityNumberLastFour)) { this.socialSecurityNumberLastFour = userInsurance.socialSecurityNumberLastFour; }

			if (isObjectNotEmpty(userInsurance.patientPhone)) { this.patientPhone = userInsurance.patientPhone; }
			if (isObjectNotEmpty(userInsurance.patientAddress)) { this.patientAddress = userInsurance.patientAddress; }
			if (isStringNotEmpty(userInsurance.relationshipToSubscriber)) { this.relationshipToSubscriber = userInsurance.relationshipToSubscriber; }

			if (isStringNotEmpty(userInsurance.insurancePhone)) { this.insurancePhone = userInsurance.insurancePhone; }
			if (isObjectNotEmpty(userInsurance.insuranceAddress)) { this.insuranceAddress = userInsurance.insuranceAddress; }

			if (isStringNotEmpty(userInsurance.subscriberFirstName)) { this.subscriberFirstName = userInsurance.subscriberFirstName; }
			if (isStringNotEmpty(userInsurance.subscriberLastName)) { this.subscriberLastName = userInsurance.subscriberLastName; }
			if (isStringNotEmpty(userInsurance.subscriberPhone)) { this.subscriberPhone = userInsurance.subscriberPhone; }
			if (isObjectNotEmpty(userInsurance.subscriberAddress)) { this.subscriberAddress = userInsurance.subscriberAddress; }

			if (isStringNotEmpty(userInsurance.payerName)) { this.payerName = userInsurance.payerName; }
			if (isStringNotEmpty(userInsurance.payerCode)) { this.payerCode = userInsurance.payerCode; }
			if (isStringNotEmpty(userInsurance.planName)) { this.planName = userInsurance.planName; }
			if (isStringNotEmpty(userInsurance.planNumber)) { this.planNumber = userInsurance.planNumber; }
			if (isStringNotEmpty(userInsurance.groupName)) { this.groupName = userInsurance.groupName; }
			if (isStringNotEmpty(userInsurance.groupNumber)) { this.groupNumber = userInsurance.groupNumber; }
			if (isStringNotEmpty(userInsurance.planType)) { this.planType = userInsurance.planType; }
			if (isStringNotEmpty(userInsurance.policyType)) { this.policyType = userInsurance.policyType; }

			if (isStringNotEmpty(userInsurance.rxBin)) { this.rxBin = userInsurance.rxBin; }
			if (isStringNotEmpty(userInsurance.rxPcn)) { this.rxPcn = userInsurance.rxPcn; }
			if (isStringNotEmpty(userInsurance.rxGroup)) { this.rxGroup = userInsurance.rxGroup; }

			if (isStringNotEmpty(userInsurance.effectiveFromDate)) { this.effectiveFromDate = userInsurance.effectiveFromDate; }
			if (isStringNotEmpty(userInsurance.effectiveToDate)) { this.effectiveToDate = userInsurance.effectiveToDate; }

			if (isStringNotEmpty(userInsurance.frontPhotoRefId)) { this.frontPhotoRefId = userInsurance.frontPhotoRefId; }
			if (isStringNotEmpty(userInsurance.backPhotoRefId)) { this.backPhotoRefId = userInsurance.backPhotoRefId; }
		}
	}

	toDto = () => {
		return {
			id: this.id,
			userId: this.userId,
			subscriberId: this.subscriberId,

			rank: this.rank,
			hierarchy: this.hierarchy,
			status: this.status,
			isMedicare: this.isMedicare,
			isMedicaid: this.isMedicaid,

			firstName: this.firstName,
			firstNameLower: this.firstNameLower,
			middleName: this.middleName,
			lastName: this.lastName,
			lastNameLower: this.lastNameLower,
			suffix: this.suffix,

			gender: this.gender,
			dateOfBirth: this.dateOfBirth,

			socialSecurityNumber: this.socialSecurityNumber,
			socialSecurityNumberLastFour: this.socialSecurityNumberLastFour,

			patientPhone: this.patientPhone,
			patientAddress: this.patientAddress,
			relationshipToSubscriber: this.relationshipToSubscriber,

			insurancePhone: this.insurancePhone,
			insuranceAddress: this.insuranceAddress,

			subscriberFirstName: this.subscriberFirstName,
			subscriberLastName: this.subscriberLastName,
			subscriberPhone: this.subscriberPhone,
			subscriberAddress: this.subscriberAddress,

			payerName: this.payerName,
			payerCode: this.payerCode,
			planName: this.planName,
			planNumber: this.planNumber,
			groupName: this.groupName,
			groupNumber: this.groupNumber,
			planType: this.planType,
			policyType: this.policyType,

			rxBin: this.rxBin,
			rxPcn: this.rxPcn,
			rxGroup: this.rxGroup,

			effectiveFromDate: this.effectiveFromDate,
			effectiveToDate: this.effectiveToDate,

			frontPhotoRefId: this.frontPhotoRefId,
			backPhotoRefId: this.backPhotoRefId
		};
	}
}

export default Insurance;